import { render, staticRenderFns } from "./uploaddrag.vue?vue&type=template&id=2e78c242"
import script from "./uploaddrag.vue?vue&type=script&lang=js"
export * from "./uploaddrag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports